/***
 *
 * Controller class for user.
 * @file Footer.js
 * @description Footer component
 * @author Naveen Kumar
 * @since 12 Oct 2021
 * 
 */

import React from 'react';
// import PropTypes from 'prop-types';
import './Footer.scss';
// import Text from '../Text/index';
import { useDispatch, useSelector } from "react-redux";
import { appDefaults } from '../../config';
import { useTranslation } from 'react-i18next';
//  import ImageWrapper from '../ImageWrapper';
import { Grid, Link, Typography, useMediaQuery, useTheme, Box } from '@mui/material';
import SiteLogo from '../SiteLogo';
//  import CustomCookieConsent from '../CustomCookieConsent';
import ReactGA from 'react-ga';
import LanguageSelector from '../LanguageSelector';
import { Navigate, history } from '../../helpers';

const Footer = ({ topMenu }) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const copyrightYear = '';
  const app = useSelector(state => state.app);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const maxSize = useMediaQuery(theme.breakpoints.up(1440));
  const meetingPlace = app?.meetingPlace || {
    "logo": "",
    "name": "",
    "countryCode": "",
    "mpid": "",
    "privacyPolicy": "",
    "contactUs": ""
  };
  const footerHeight = (matches || !topMenu) ? '240px' : '312px';
  let logoPosition = 2;
  let logoMarginLeft = 0;
  if (meetingPlace?.name === 'Livat Hammersmith') {
    logoPosition = 1;
    logoMarginLeft = -1.6;
  }

  const meetingPlaceLinkSx = {
    fontWeight: "700",
    textUnderlineOffset: "2px",
    textDecorationSkipInk: "none",
  }

  const copywrite = () => {
    return (
      <>
        <Typography style={{ fontSize: 12, fontFamily: 'NotoIKEALatin' }} >
          {`© ${copyrightYear || appDefaults?.copyright?.year}`}
        </Typography>
        <Typography style={{ fontSize: 12, fontFamily: 'NotoIKEALatin' }}>
          {appDefaults?.copyright?.text}
        </Typography>
      </>
    )
  }

  return (
    <footer data-testid="Footer">
      <Box className={matches ? "footerBg" : "footerBgMobile"} height={footerHeight} width={'100%'}>
        <Grid container px={{ xs: 5, md: (maxSize ? 0 : 21) }} py={3}
          justifyContent={{ xs: 'flex-start', md: 'space-between' }} alignItems={{ xs: 'flex-start', md: 'center' }}
          flexDirection={{ xs: 'column', md: 'row' }} flexWrap={'nowrap'} height={'100%'} maxWidth={'1440px'} mx={'auto'}>
          {/** === Mobile Layout === */}
          {!matches && (
            <>
              <Grid item mb={1}>
                <LanguageSelector topMenu={topMenu} />
              </Grid>

              {topMenu && (
                <Grid item mb={4}>
                  <Link
                    variant="subtitle1"
                    aria-label={t('S_BACK_TO_HOMEPAGE')}
                    sx={meetingPlaceLinkSx}
                    color="inherit"
                    component="button"
                    onClick={() => { Navigate(3000, { dispatch, history }) }}
                  >
                    {`${app?.meetingPlace?.name} | ${app?.country?.name}`}
                  </Link>
                </Grid>
              )}

              <Grid item mb={1}>
                <Link
                  variant="body1"
                  className="link"
                  color="inherit"
                  component="a"
                  href={meetingPlace?.privacyPolicy}
                  target="_blank"
                  minHeight={'24px'}
                  display={'inline-block'}
                  rel="noreferrer"
                >
                  {t("S_PRIVACY_POLICY")}
                </Link>
              </Grid>

              <Grid item mb={1}>
                <Link
                  variant="body1"
                  className="link"
                  color="inherit"
                  component="a"
                  href={meetingPlace?.contactUs}
                  minHeight={'24px'}
                  display={'inline-block'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("S_CONTACT_US")}
                </Link>
              </Grid>

              <Grid item>
                <SiteLogo className="mplogo-footer" />
              </Grid>
              <Grid item mb={1}>
                {copywrite()}
              </Grid>
            </>
          )}

          {/** === Desktop Layout === */}
          {matches && (
            <>
              <Grid item>
                <SiteLogo className="mplogo-footer" />
              </Grid>

              <Grid item>
                <Grid container flexDirection="column">
                  <Grid item mb={1}>
                    <Link
                      variant="subtitle1"
                      aria-label={t('S_BACK_TO_HOMEPAGE')}
                      sx={meetingPlaceLinkSx}
                      color="inherit"
                      component="button"
                      onClick={() => { Navigate(3000, { dispatch, history }) }}
                    >
                      {`${app?.meetingPlace?.name} | ${app?.country?.name}`}
                    </Link>
                  </Grid>

                  <Grid item mb={3}>
                    <Link
                      variant="body1"
                      className="link"
                      color="inherit"
                      component="a"
                      display={'inline-block'}
                      minHeight={'24px'}
                      href={meetingPlace?.privacyPolicy}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("S_PRIVACY_POLICY")}
                    </Link>
                  </Grid>

                  <Grid item mb={0}>
                    <Link
                      variant="body1"
                      className="link"
                      color="inherit"
                      component="a"
                      minHeight={'24px'}
                      display={'inline-block'}
                      href={meetingPlace?.contactUs}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("S_CONTACT_US")}
                    </Link>
                  </Grid>

                  <Grid item>
                    {copywrite()}
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </footer>
  )
};

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
